import { UserType } from '../../entities/tenant/user.type';
import { AppSecurityRight } from '../modules/app.security';
import { withFieldAppReleaseRights } from '../modules/field.app.section.rights';
import { MobileTechniciansSecurityRight } from '../modules/mobile.technicians.security.module';
import { withPortalContractorReleaseRights } from '../modules/portal.contractor.section.rights';
import { PortalContractorSecurityRight } from '../modules/portal.contractors.security.module';
import { SecurityRole, SecurityRoleType } from '../security.role';

export class SubcontractorUser implements SecurityRole {

    _id = 'b040e1b4-20f6-4083-b0c2-0f043ae7cc17';
    system = true;
    hidden = false;
    type = UserType.Subcontractor;
    name = SecurityRoleType.SubcontractorUser;
    description = 'Can use the mobile app to update progress of jobs. These users work for 3rd party subcontractors.';
    rights = withFieldAppReleaseRights(withPortalContractorReleaseRights([
        AppSecurityRight.LoginContractor,
        AppSecurityRight.LoginField,
        MobileTechniciansSecurityRight.CanAccessJobs,
        PortalContractorSecurityRight.CanAccessJobs,
        PortalContractorSecurityRight.ManageCompliance,
        MobileTechniciansSecurityRight.CanAccessTimesheets,
        MobileTechniciansSecurityRight.AllowEditBeforeCheckIn,
        // Read-only visibility of job items, including the field app's SOR tab. View, not manage:
        // ManageCodesOnJob / ManagePendingItems stay off, so this grants no write.
        MobileTechniciansSecurityRight.ManageJobViewItems,
    ]));

}

